import script from "./TechnologyDay2024View.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyDay2024View.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyDay2024View.vue?vue&type=style&index=0&id=5a634f6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a634f6a"]])

export default __exports__